(function () {
  const settings = window.FreeGiftSettings;
  const LOG = (...args) => console.log('[FreeGift]', ...args);

  LOG('Settings primite:', settings);

  if (!settings || !settings.enabled) { LOG('Dezactivat.'); return; }
  if (!settings.variantId)            { LOG('EROARE: variantId lipsa!'); return; }
  if (!settings.threshold)            { LOG('EROARE: threshold lipsa!'); return; }

  const VARIANT_ID = Number(settings.variantId);
  const THRESHOLD  = Number(settings.threshold);
  const ROOT_URL   = window.Shopify.routes.root;

  LOG('Varianta ID:', VARIANT_ID, '| Prag (subunitati):', THRESHOLD, '| Prag (valoare):', THRESHOLD / 100);

  function fetchCart() {
    return fetch(ROOT_URL + 'cart.json').then(r => r.json());
  }

  function isGiftItem(item) {
    return (
      item.variant_id === VARIANT_ID &&
      item.properties &&
      item.properties._free_gift === 'true'
    );
  }

  function getGiftLines(cart) {
    return cart.items
      .map((item, index) => ({ item, index })) // index 0-based
      .filter(({ item }) => isGiftItem(item));
  }

  function addGift() {
    LOG('Adaug produsul gratuit...');
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: VARIANT_ID,
        quantity: 1,
        properties: { _free_gift: 'true' }
      })
    }).then(r => r.json());
  }

  function changeLineQuantity(line, quantity) {
    LOG('Setez linia', line, 'la quantity =', quantity);
    return fetch(ROOT_URL + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    }).then(r => r.json());
  }

  function removeGiftLine(line) {
    return changeLineQuantity(line, 0);
  }

  function setGiftLineToOne(line) {
    return changeLineQuantity(line, 1);
  }

  function triggerCartUIUpdate() {
    const cartDrawer = document.querySelector('m-cart-drawer');
    if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
      cartDrawer.onCartDrawerUpdate();
    }

    fetchCart().then(cart => {
      if (window.MinimogEvents && window.MinimogTheme) {
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, cart);
      }
      document.dispatchEvent(
        new CustomEvent('theme:cart:update', { bubbles: true, detail: cart })
      );
    });
  }

  let processing = false;

  async function normalizeGiftLines(cart) {
    const giftLines = getGiftLines(cart);

    if (!giftLines.length) return false;

    let changed = false;

    // păstrăm doar prima linie de cadou; orice extra se șterge
    const [firstGift, ...extraGifts] = giftLines;

    if (firstGift.item.quantity !== 1) {
      LOG('Cadoul are quantity != 1. Corectez la 1.');
      await setGiftLineToOne(firstGift.index + 1); // line e 1-based
      changed = true;
    }

    for (const gift of extraGifts) {
      LOG('Linie suplimentara de cadou detectata. O sterg.', gift.index + 1);
      await removeGiftLine(gift.index + 1);
      changed = true;
    }

    return changed;
  }

  async function evaluate(cart) {
    if (processing) return;

    processing = true;

    try {
      LOG('Evaluez cosul. Items:', cart.items.length, '| total_price:', cart.total_price);

      const giftLines = getGiftLines(cart);
      const hasGift = giftLines.length > 0;

      // subtotal fara toate liniile de cadou
      let subtotal = cart.total_price;
      for (const { item } of giftLines) {
        subtotal -= item.line_price;
      }

      LOG('Subtotal fara cadou:', subtotal, '| Prag:', THRESHOLD, '| Are cadou:', hasGift);

      if (subtotal >= THRESHOLD) {
        if (!hasGift) {
          LOG('>>> Prag atins, adaug cadoul.');
          await addGift();
          triggerCartUIUpdate();
          return;
        }

        // dacă există deja, îl forțăm să rămână la quantity = 1
        const normalized = await normalizeGiftLines(cart);
        if (normalized) {
          LOG('Cadoul a fost normalizat.');
          triggerCartUIUpdate();
          return;
        }

        LOG('Cadoul exista deja si este corect.');
      } else {
        if (hasGift) {
          LOG('>>> Sub prag, sterg toate liniile de cadou.');
          for (const gift of [...giftLines].reverse()) {
            await removeGiftLine(gift.index + 1);
          }
          triggerCartUIUpdate();
          return;
        }

        LOG('Sub prag si fara cadou. Nicio actiune necesara.');
      }
    } catch (e) {
      console.error('[FreeGift] Eroare evaluate:', e);
    } finally {
      processing = false;
    }
  }

  function checkAndHandleGift(cartOrDetail) {
    if (processing) return;

    const hasItems = cartOrDetail && Array.isArray(cartOrDetail.items);
    if (!hasItems) {
      LOG('Detail incomplet, fetch complet cart...');
      fetchCart().then(evaluate);
      return;
    }

    evaluate(cartOrDetail);
  }

  document.addEventListener('theme:cart:add', e => {
    LOG('Event: theme:cart:add');
    checkAndHandleGift(e.detail);
  });

  document.addEventListener('theme:cart:update', e => {
    LOG('Event: theme:cart:update');
    checkAndHandleGift(e.detail);
  });

  LOG('Verificare initiala...');
  fetchCart().then(evaluate);
})();